var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-english {\n        fill: #000;\n      }\n\n      .cls-1-english, .cls-2-english {\n        stroke-width: 0px;\n      }\n\n      .cls-2-english {\n        fill: #ff7aac;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M95.5,163.1c-5.2,4.7-20.6,13-41.4,13C21.8,176.1,0,155.9,0,124.9s20.6-52.4,51.3-52.4,47.8,23.7,47.8,50.9v9.5H23.7c1.4,12.6,12.8,24.3,34.4,24.3s25.1-6.2,30.3-10.3l7.2,16.3h0ZM75.2,114.4c-.6-12.8-9.1-23.9-24.3-23.9s-25.2,8.5-27,23.9h51.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M184.8,78.8c-6.7-4.5-14.7-6.8-22.8-6.6-30.2,0-51.5,21.6-51.5,53.2s26.5,50.9,54.2,50.9,30.2-4.2,43.1-12.3V29.8h-23v49.1h0ZM156.9,157.2c-8.4,0-17.5-3.5-22.2-8.8v-52.1c6.1-3.5,13-5.3,20.1-5.1,16,0,30,12.7,30,31.8s-10.9,34.1-27.9,34.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M391.9,75c-2.6,2.3-10.2,6.5-20.6,6.5-16.1,0-26.9-10-26.9-25.5s10.2-26.1,25.5-26.1,23.7,11.8,23.7,25.3v4.7h-37.4c.7,6.3,6.4,12.1,17.1,12.1s12.5-3.1,15-5.1l3.6,8.1h0ZM381.8,50.8c-.3-6.4-4.5-11.9-12.1-11.9s-12.5,4.2-13.4,11.9h25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M435.4,80v-26.5c0-8.5-1.5-13.5-9.5-13.5s-9.6,3.6-11.2,5.6v34.4h-11.4V31.3h11.4v5c2.5-2.3,8.1-6.4,15.6-6.4s16.4,5.3,16.4,17.6v32.5h-11.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M492.5,75.7c-3.3,3.6-9,5.8-13.2,5.8-11.6,0-22.9-9.8-22.9-25.8s12.7-25.8,26.8-25.8,16.1,2.5,20.6,5v47.4c0,18.4-12.2,23.8-23.5,23.8s-18.2-3.5-22-5.9l4.7-8.7c2.5,1.9,9.1,5.1,17,5.1s12.4-3.1,12.4-12.8v-8.2h.1ZM492.5,41.3c-1.9-.9-5.1-2-8.9-2-7.9,0-15.2,4.7-15.2,16.4s4,16.2,13,16.2,9.2-2.7,11.1-5.9v-24.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M516.5,80V.9h11.4v79.1h-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M539.4,15.6c0-4.3,3.1-7.3,7.2-7.3s7.3,3.1,7.3,7.3-3.1,7.3-7.3,7.3-7.2-3-7.2-7.3ZM541,80V31.3h11.4v48.7h-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M565.2,67c2.9,2.8,8.5,5.9,13.5,5.9s7.2-2.4,7.2-5.6c0-9-21.5-10-21.5-23.5s6.4-14,17-14,13.8,3.7,15.9,5.5l-4.2,7.9c-.8-.9-5.2-4.7-10.3-4.7s-6.4,2-6.4,4.9c0,8.1,21.1,8.5,21.1,23.3s-7.1,14.8-18.2,14.8-14.7-3.4-18.3-6.4l4.2-8.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-english",
    d: "M639.5,80v-26.5c0-8.5-1.5-13.5-9.5-13.5s-9.7,3.6-11.2,5.6v34.4h-11.4V.9h11.4v35.4c2.5-2.3,8.1-6.4,15.6-6.4s16.4,5.3,16.4,17.6v32.5h-11.4.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M419.4,96h-.6c-4.3.2-7.6,3.8-7.4,8.1h0v.3c0,4.4,3.8,7.9,8.2,7.9s8-3.8,7.9-8.2v-.8c-.2-4.2-3.8-7.5-8.1-7.3h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-english",
    x: 413.1,
    y: 121.4,
    width: 12.5,
    height: 53.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M453.5,129.7v-8.3h-12.5v53.6h12.5v-29.8c0-6.7,3.5-13.5,9.5-13.5s5.1.9,7.1,2.5l4.6-11.7c-2.9-1.8-6.2-2.7-9.6-2.7-6.3,0-10.5,7.2-11.7,9.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M506.5,119.9c-16.8,0-28,12.1-28,28.7s11.9,28,29.6,28c8.1.2,16.1-2.3,22.6-7.1l-3.9-8.9c-4.7,3.7-10.6,5.7-16.6,5.6-11.8,0-18-6.4-18.8-13.3h41.2v-5.2c0-14.9-8.7-27.8-26.1-27.8h0ZM491.5,142.9c.6-7.6,7.1-13.3,14.8-13.1h.5c7.1,0,12.8,5.9,12.7,13.1h-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M570.8,166.4h-.8c-9.3-.6-16.3-8.6-15.8-17.9,0-11.6,8-18,16.6-18,4.8.1,9.4,2,13,5.2l4.8-9.4c-5.2-4.1-11.6-6.3-18.3-6.3-15.5-.2-28.2,12-28.7,27.5-.5,15.7,11.8,28.8,27.5,29.2,7.8.4,15.4-2.4,21.1-7.8l-4-8.7c-4,4.1-9.6,6.3-15.3,6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M665.3,119.9c-15.7-.3-28.6,12.1-29,27.7-.3,15.7,12.1,28.6,27.7,29h.6c15.6,0,28.3-12.6,28.3-28.3s-12.3-28.1-27.7-28.4h.1ZM679.8,148.4c0,10.9-6.3,17.8-15.8,17.8h-.2c-9.2-.5-16.2-8.4-15.7-17.5,0-11,6.9-18.3,16.1-18.3s15.5,7.2,15.5,18h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M717.4,129.7v-8.3h-12.5v53.6h12.5v-29.8c0-6.7,3.5-13.5,9.5-13.5s5.1.9,7.1,2.5l4.6-11.7c-2.9-1.8-6.2-2.7-9.6-2.7-6.3,0-10.5,7.2-11.7,9.8h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-english",
    points: "785.6 121.4 769.7 155.3 753.9 121.4 740 121.4 762.6 168.2 743.7 202.2 757.8 202.2 800 121.4 785.6 121.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M386,121.8c-3.8-2.5-8.3-3.8-12.8-3.7-17,0-28.9,12.2-28.9,29.9s14.9,28.6,30.5,28.6,17-2.4,24.2-6.9v-75.5h-12.9v27.6h-.1ZM370.3,165.8c-4.7,0-9.9-2-12.5-4.9v-29.3c3.4-2,7.3-3,11.3-2.8,9,0,16.9,7.1,16.9,17.9s-6.1,19.2-15.7,19.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M627.7,165.9h0c-9.9-1-15.3-6.8-16-13.1v-16.1h20v-10.3h-20v-30.2h-13v53h0c.4,16.7,12.2,27.5,29.8,27.5s5.3-.3,7.8-.9c-3.7-2.5-6.7-5.9-8.7-9.9h.1Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-english",
    x: 272.4,
    y: 28.6,
    width: 7.1,
    height: 146
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M132.9,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M155.5,277.2v-37c3.2-2.3,7.2-3.4,10.9-3.4,7.3,0,14.1,4.6,14.1,13.8s-4.6,13.6-12.7,13.6-6.9-1.7-8.8-3.5v16.6h-3.6ZM159.1,256.7c1.7,2.4,5.1,4.3,8.7,4.3s9-3.9,9-10.4-4-10.6-10.7-10.6-5.7,1.1-7,2.2v14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M209.5,259.8c-1.7,2.4-5.7,4.3-10.8,4.3-7.7,0-13.4-5.5-13.4-13.6s5.2-13.8,13.2-13.8,11.7,6.4,11.7,13v1h-21.3c0,6.4,4.2,10.4,10.5,10.4s7.2-2.1,8.4-3.4l1.7,2.2ZM206.6,247.8c-.4-4.3-3.1-8-8.2-8s-8.6,2.8-9.3,8h17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M238.9,259.7c-2.1,2.7-5.8,4.4-10.5,4.4-7.6,0-13.4-5.8-13.4-13.6s5.8-13.8,13.8-13.8,8.4,2.7,9.1,3.5l-1.9,2.4c-.6-.6-3.3-2.8-7.3-2.8s-10,3.5-10,10.6,4.6,10.5,10.2,10.5,6.6-1.6,8.3-3.3l1.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M246.6,232.2c-1.5,0-2.8-1.2-2.8-2.7s1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7ZM244.8,263.4v-26h3.6v26h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M276.8,260.4c-2.4,2.3-6.3,3.7-11.3,3.7-7.6,0-11.1-4.5-11.1-9.4s6.2-8.5,10.7-8.5,6.2.9,8.2,2.9v-3.6c0-3.2-2.5-5.7-7.1-5.7s-6.4,1.2-7.2,1.6l-1.4-2.7c1.8-.9,4.7-1.9,8.6-1.9,8.4,0,10.6,4,10.6,9.8v13.9ZM273.3,252.2c-1.5-1.4-4.1-3.1-7.8-3.1s-7.4,1.8-7.4,5.6,3.5,6.4,7.6,6.4,5.9-.9,7.6-2.2v-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M284.7,263.4v-44.3h3.6v44.3h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M298.7,232.2c-1.5,0-2.8-1.2-2.8-2.7s1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7ZM296.9,263.4v-26h3.6v26h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M307.9,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M332.6,263.4v-22.8h-4.8v-3.1h4.8v-9.3h3.6v9.3h6.3v3.1h-6.3v22.8h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M382.8,259.8c-1.7,2.4-5.7,4.3-10.8,4.3-7.7,0-13.4-5.5-13.4-13.6s5.2-13.8,13.2-13.8,11.7,6.4,11.7,13v1h-21.3c0,6.4,4.2,10.4,10.5,10.4s7.2-2.1,8.4-3.4l1.7,2.2ZM379.9,247.8c-.4-4.3-3.1-8-8.2-8s-8.6,2.8-9.3,8h17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M408.1,263.4v-15.3c0-5.6-1.8-8-6.9-8s-6.6,2.2-7.7,3.5v19.9h-3.6v-26h3.6v2.8c1.5-1.3,4.4-3.5,8.7-3.5s9.5,3,9.5,9.7v17h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M439.3,259.9c-2.1,2.5-5.7,4.2-8.9,4.2-6.2,0-12.5-5-12.5-13.6s6.9-13.8,14.2-13.8,8.9,1.9,10.7,3.3v24.8c0,9.8-6.3,12.7-12.1,12.7s-7.6-1.1-10.5-3l1.6-2.8c2.4,1.6,5.8,2.6,9,2.6s8.5-1.4,8.5-9.3v-5.2ZM439.3,241.8c-.9-.5-3.5-1.9-7.2-1.9-5.3,0-10.4,3.4-10.4,10.6s2.8,10.4,9.6,10.4,6.5-2.1,8-4.8v-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M451.1,263.4v-44.3h3.6v44.3h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M465.1,232.2c-1.5,0-2.8-1.2-2.8-2.7s1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8-1.2,2.7-2.8,2.7ZM463.3,263.4v-26h3.6v26h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M474.4,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M515.3,263.4v-15.3c0-5.6-1.8-8-6.9-8s-6.6,2.2-7.7,3.5v19.9h-3.6v-44.3h3.6v21.1c1.5-1.3,4.4-3.5,8.7-3.5s9.5,3,9.5,9.7v17h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M541.6,263.4v-22.8h-4.8v-3.1h4.8v-9.3h3.6v9.3h6.3v3.1h-6.3v22.8h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M574.5,237.4h3.6v23.1c-2.6,2.4-6.2,3.6-10.9,3.6s-11-3.3-11-10v-16.7h3.6v15.9c0,5.3,3.1,7.7,7.6,7.7s5.9-1.1,7.2-2.1v-21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M588,263.4v-22.8h-4.8v-3.1h4.8v-9.3h3.6v9.3h6.3v3.1h-6.3v22.8h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M614.4,264.1c-7.8,0-13.9-5.9-13.9-13.7s6.1-13.7,13.9-13.7,13.8,6.2,13.8,13.7-6,13.7-13.8,13.7ZM624.4,250.4c0-6.1-4.6-10.6-10.1-10.6s-10.2,4.5-10.2,10.7,4.9,10.4,10.1,10.4,10.2-4.2,10.2-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M634.6,263.4v-26h3.6v3.7c.3-1.2,2.6-4.4,5.6-4.4s3.8.9,4.4,1.2l-1.7,3.4c-.5-.4-1.6-1.1-3-1.1-3,0-5,3.3-5.2,5.5v17.7h-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-english",
    d: "M651.6,257.8c1.2,1.4,3.6,3.3,7.2,3.3s5.5-1.6,5.5-5c0-5.8-12.5-5.3-12.5-12.5s3.1-7,8-7,6.3,1.6,7.6,3l-1.6,2.6c-.6-.7-3-2.7-5.9-2.7s-4.5,2.1-4.5,3.8c0,5.1,12.5,4.2,12.5,12.7s-3.8,8-9.1,8-7.6-2.1-9.1-3.8l1.8-2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishLogo);
export default __webpack_public_path__ + "static/media/english-logo.036954e2a9f748490d0cf86b70c4ed3f.svg";
export { ForwardRef as ReactComponent };